var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-row",
    {
      staticClass: "image-row",
      staticStyle: { "padding-bottom": "10px" },
      attrs: { gutter: 20 },
    },
    _vm._l(_vm.images, function (item, index) {
      return _c("el-col", { key: index, attrs: { xs: 12, sm: 8, md: 6 } }, [
        _c(
          "div",
          { staticClass: "grid-item-box" },
          [
            _c(
              "div",
              {
                staticClass: "image-title",
                class: { "is-required": item.required },
              },
              [_vm._v(_vm._s(item.name))]
            ),
            _c("ouer-uploader", {
              attrs: {
                "has-error": item.error,
                "err-message": `请上传${item.name}`,
                disabled: _vm.disabled,
              },
              on: { change: _vm.onChange },
              model: {
                value: _vm.images[index],
                callback: function ($$v) {
                  _vm.$set(_vm.images, index, $$v)
                },
                expression: "images[index]",
              },
            }),
          ],
          1
        ),
      ])
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }